import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { useAdminUserContext } from "../../../modules/common/providers/AdminUserProvider";
import RestrictedOutlet from "./RestrictedOutlet";

export default function RouteLayout() {
  const { user } = useAdminUserContext();
  const isAdmin = user?.role === "ADMIN";

  return (
    <div className="flex h-screen flex-col">
      <Topbar isAdmin={isAdmin} />
      <div className="h-outlet flex w-screen flex-1 overflow-hidden">
        <Sidebar isAdmin={isAdmin} />
        <RestrictedOutlet isAdmin={isAdmin} user={user} />
      </div>
    </div>
  );
}
